import { Box, Grid, styled } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import { Link } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';

export const InsuranceDocumentValue = styled('span')(({ theme }) => ({
  color: theme.palette.text.highlight,
  fontWeight: theme.typography.fontWeightMedium
}));

export const InsuranceListHeaderLinksWrapper = styled(Box)(() => ({
  minWidth: '100px',
  flexGrow: 1,
  display: 'flex',
  justifyContent: 'end'
}));

export const InsuranceDocumentCard = styled(Card, { shouldForwardProp: prop => prop !== 'gradientColor' })(({ theme, gradientColor }) => ({
  background: `linear-gradient(to right, ${theme.palette.common.white} 50%, ${gradientColor || '#ffc307'} 90%)`,
  '&:hover': {
    background: `linear-gradient(to right, ${theme.palette.common.white} 100%, ${gradientColor || '#ffc307'} 0%) !important`
  }
}));

export const InsuranceDocumentCardContentWrapper = styled(Grid)(({ theme }) => ({
  position: 'relative',
  minHeight: theme.spacing(5)
}));

export const InsuranceDocumentEditButton = styled(Link)(() => ({
  position: 'absolute',
  bottom: 0,
  right: 0
}));

export const InsuranceDocumentEditButtonIcon = styled(EditIcon)(({ theme }) => ({
  width: theme.spacing(2.5),
  height: theme.spacing(2.5)
}));

export const InsuranceDocumentAssetImage = styled('img')(() => ({
  height: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
  objectFit: 'contain',
  maxHeight: '130px',
  display: 'block'
}));
